import React, { Component }  from 'react';
import moment                from 'moment';
import { connect }           from 'react-redux';
import { Link }              from 'react-router-dom';
import ReactTooltip          from 'react-tooltip';
import FlashRetornoNulo      from '../../../container/FlashRetornoNulo';
import { removerTarefa}      from '../../../actions/tarefaAction';

class missao_professor_lista extends Component {

    acaoRemoverTarefa(id){
        const acao  = window.confirm("Deseja Remover?");
        if (acao) {
          this.props.removerTarefa(id);
         }
    }
    
    renderListaTarefas(){

        const dados = this.props.listaTarefas.filter(elem => (this.props.status === 1 || this.props.status === 0 ? elem.tar_status === 1 || elem.tar_status === 0 : elem.tar_status ===2));
        const lar              = {width : '20%'}
        const lar2             = {width : '30%'}
        let status             = ''
      
        if (dados.length) {

           return dados.map((elem,i)=>{
              
               switch (elem.tar_status) {
                   case 0: status = <span className="label label-default">não iniciado</span>; break;
                   case 1: status = <span className="label label-success">iniciado</span>; break;
                   case 2: status = <span className="label label-danger">finalizado</span>; break;
               }

             return  <tr key={i}> 
                        <td className="text-center">{elem.tar_id}</td>
                        <td className="text-center" style={lar2}>{elem.tur_nome}</td>
                        <td className="text-center" style={lar2}>{elem.tar_titulo}</td>
                        <td className="text-center" style={lar}>{moment(elem.tar_data_inicio).format('DD/MM/YYYY')}</td>
                        <td className="text-center" style={lar}>{moment(elem.tar_data_fim).format('DD/MM/YYYY')}</td>
                        <td className="text-center" style={lar}>{status}</td>
                        <td className="text-center" style={lar}>
                          
                                <div>
                                    <Link  to={`${this.props.menu.missao.editar}/${elem.tar_id}`} data-tip data-for={'editar_'+elem.tar_id} className="btn btn-warning btn-xs">
                                        <span className="glyphicon glyphicon-pencil"></span>
                                    </Link>
                                    <ReactTooltip id={'editar_'+elem.tar_id} type='dark' effect='solid'>
                                        <span>Editar Tarefa</span>
                                    </ReactTooltip>
                                </div>
                                

                        </td>
                        <td className="text-center" style={lar}>
                              <button className="btn btn-danger btn-xs" data-tip data-for={'excluir_'+elem.tar_id} disabled={elem.tar_status === 2 ? true:false} onClick={this.acaoRemoverTarefa.bind(this,elem.tar_id)}><span className="glyphicon glyphicon-remove-sign"></span></button>
                              <ReactTooltip id={'excluir_'+elem.tar_id} type='dark' effect='solid'>
                                <span>Excluir Tarefa</span>
                            </ReactTooltip> 
                        </td>     
                        <td className="text-center" style={lar}>
                            <Link  to={`${this.props.menu.missao.resposta}/${this.props.dis_id}/${elem.tar_id}/${elem.tar_cod_turma}`} data-tip data-for={'resposta_'+elem.tar_id} className="btn btn-primary btn-xs">
                              <span className="glyphicon glyphicon-eye-open"></span>
                            </Link>
                            <ReactTooltip id={'resposta_'+elem.tar_id} type='dark' effect='solid'>
                              <span>Ver respostas</span>
                            </ReactTooltip>
                        </td>                   
                    </tr>;
         });

        }else{

            return <tr> <td colSpan={9} className="text-center"><FlashRetornoNulo/></td></tr>;
        }
    }

    render() {
        return (
               <div className="panel panel-azul-claro panel-cinza">
                        <div className="panel-body table-responsive">
                            <table className="table table_panel">
                                <thead>
                                    <tr>
                                       <th className="text-center">#</th>
                                       <th className="text-center">Turma</th>
                                       <th className="text-center">Título</th>                                     
                                       <th className="text-center">Início</th>
                                       <th className="text-center">Término</th>
                                       <th className="text-center">Status</th>
                                       <th className="text-center">Editar</th>
                                       <th className="text-center">Excluir</th>
                                       <th className="text-center">Respostas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                  {this.renderListaTarefas()}                                
                                </tbody>
                            </table>
                        </div>
                    </div>
        );
    }
}


function mapStateToProps(state){

    return {
        session      : state.auth.session,
        listaTarefas : state.tarefaReducer.all_tarefas,
        menu         : state.configReducer.menu
        }

}

export default connect(mapStateToProps,{removerTarefa})(missao_professor_lista);



// WEBPACK FOOTER //
// ./src/components/professor/missoes/missao_professor_lista.js